import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { ErrorHandler } from '@playbookux/playbook-web-core';

import {
  Button,
  ButtonArea,
  ButtonInverted,
  Container,
  Content,
  CustomDatePicker,
  Dialog,
  Header,
  Input,
  Row,
  Text,
} from './styles';

const AddTesterModal = ({
  error, loading, onClose, onSubmit, show,
}) => {
  const [value, setValue] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [inputError, setInputError] = useState();

  const inputRef = useRef(null);

  useEffect(() => {
    if (!show) {
      setValue('');
      setStartDate(new Date());
    }
    if (show) inputRef.current.focus();
  }, [show, value]);

  const handleChange = (e, { value: newValue }) => {
    setInputError(null);
    setValue(newValue);
  };

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog>
        <Header as="h1">
          Add new tester
        </Header>

        <Content>
          <Row>
            <Text>Name</Text>
            <Input
              placeholder="Enter tester ID or email"
              value={value}
              onChange={handleChange}
              ref={inputRef}
            />
          </Row>

          <Row>
            <Text>Date</Text>
            <CustomDatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
            />
          </Row>

          {inputError && (
            <Text.Error>
              {inputError}
            </Text.Error>
          )}

          {(error) && (
            <ErrorHandler
              error={error}
              defaultMessage="Error while saving."
            />
          )}

          <ButtonArea>
            <ButtonInverted onClick={onClose}>
              Cancel
            </ButtonInverted>

            <Button
              onClick={() => onSubmit(value, startDate.toUTCString())}
              disabled={loading || inputError || !value}
              loading={loading}
            >
              Save
            </Button>
          </ButtonArea>

        </Content>
      </Dialog>
    </Container>
  );
};

AddTesterModal.propTypes = {
  error: PropTypes.PropTypes.shape({
    message: PropTypes.string,
  }),
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

AddTesterModal.defaultProps = {
  error: null,
  loading: false,
};

export default AddTesterModal;
